import { globalModalsConfig } from '@/components/Base/Modal/Global/config'

export const state = () => ({
  isOpen: false,
  modalConfig: {},
  props: {},
  onCancel: null,
})

export const mutations = {
  set_isOpen(state, isOpen) {
    state.isOpen = isOpen
  },
  reset(state) {
    state.modalConfig = {}
    state.props = {}
  },
  set_modalConfig(state, modalConfig) {
    state.modalConfig = modalConfig
  },
  set_props(state, props) {
    state.props = props
  },
}

export const actions = {
  open_globalModal({ commit }, { config, props = {} }) {
    commit('set_isOpen', true)
    commit('set_modalConfig', config)
    commit('set_props', props)
  },
  close_globalModal({ commit }) {
    commit('set_isOpen', false)
  },
  reset_globalModal({ commit }) {
    commit('reset')
  },
  onCancel({ state }) {
    if (!state.onCancel) return
    state.onCancel()
  },
  actRemove_globalModalProps({ commit }) {
    commit('set_props', {})
  },
  /**
   * Open shortcuts
   **/
  open_globalModalSupport({ dispatch }) {
    dispatch('open_globalModal', { config: globalModalsConfig.support })
  },
  open_globalModalAccountBlocked({ dispatch }) {
    dispatch('open_globalModal', { config: globalModalsConfig.accountBlocked })
  },
  open_globalModalUserHasBeenLoggedOut({ dispatch }) {
    dispatch('open_globalModal', { config: globalModalsConfig.userHasBeenLoggedOut })
  },
  open_globalModalPromocode({ dispatch }) {
    dispatch('open_globalModal', { config: globalModalsConfig.promoCode })
  },
  open_globalModalRedirectReVerification({ dispatch }) {
    dispatch('open_globalModal', { config: globalModalsConfig.redirectReVerification })
  },
  open_globalModalRedirectVerificationError({ dispatch }) {
    dispatch('open_globalModal', { config: globalModalsConfig.redirectVerificationError })
  },
}

export const getters = {
  get_globalModalConfig: (state) => state.modalConfig,
  get_globalModalProps: (state) => state.props,
  get_globalModalIsOpen: (state) => state.isOpen,
}
